import React, { Component } from 'react';
import axios from 'axios';
import { FaRegStar } from "react-icons/fa";
import { FaStar } from "react-icons/fa";


class AddReview extends Component {
  state = {
    rating: 0,
    comment: "",
    isActive: false,
    windowHeight: window.innerHeight - 60,
    error: null,
    loading: false, // Added loading state
    reviewID: 0,
  };
  // for the image 
  fileInputRef = React.createRef();






  fetchCourses = async () => {
    const accessToken = localStorage.getItem("accessToken");
    try {
        const course_id = this.props.course_id
        const courseId = parseInt(course_id, 10);
        let headers = {}; // Initialize an empty headers object

        if (accessToken) {
            headers = {
                Authorization: `Bearer ${accessToken}`,
            };
        }

        const response = await axios.get(`https://api.geoinfoacademy.com/api/courses/${courseId}/reviews/`, {
            headers: headers,
        });
        this.setState({ reviews: response.data, // Assuming the API returns an array of review objects
    }, () => {
      // Call the filtering function after the state has been updated
      this.filterOutCurrentUserReviews();
    });
        console.log("API Response - add rating in the form:", response.data);
    } catch (error) {
        console.error("Error fetching data for review:", error);
    }
};

filterOutCurrentUserReviews = () => {
    const loggedInUser = JSON.parse(localStorage.getItem("user"));

    if (loggedInUser && this.state.reviews && Array.isArray(this.state.reviews)) {
        const currentUserReviews = this.state.reviews.filter(review => {
            const firstName = review.user.first_name;
            const lastName = review.user.last_name;
            const formattedFirstName = firstName.charAt(0).toUpperCase() + firstName.slice(1);
            const formattedLastName = lastName.charAt(0).toUpperCase() + lastName.slice(1);
            const reviewerFullName = `${formattedFirstName} ${formattedLastName}`;
            return reviewerFullName === loggedInUser.name;
        });

        if (currentUserReviews.length > 0) {
            const firstReview = currentUserReviews[0];
            this.setState({
                rating: firstReview.rating,
                comment: firstReview.comment,
                reviewID: firstReview.id,
            });
            console.log("Current user's first existing review:", firstReview);
        } else {
            console.log("No existing review found for the current user.");
        }
    } else {
        console.log("Could not check for existing review: user data not found or reviews not an array.");
    }
};


  // start of the handle submition


  handleInputChange = (event) => {
    const { name, value} = event.target;
      this.setState({ [name]: value });
  };
 
  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true, error: null });
    const formData = new FormData();
    formData.append('rating', this.state.rating);
    formData.append('comment', this.state.comment);


    try {
      const course_id = this.props.course_id
      const courseId = parseInt(course_id, 10);
      const accessToken = localStorage.getItem('accessToken');
      const response = await axios.post(`https://api.geoinfoacademy.com/api/courses/${courseId}/reviews/`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      console.log('API response:', response);
      this.fetchCourses()
      this.setState({
        rating: this.state.rating,
        comment: this.state.comment,
      });
      if (this.props.onRefresh) { // Changed from onDocumentSubmit to onRefresh
        this.props.onRefresh(); // Call the callback to signal the parent
    }
    } catch (error) {
      console.error('Error submitting form:', error);

    }
    finally {
      this.setState({ loading: false }); // Set loading to false after response
    }
  };


  
  // end for the submition

 




  // the display
  handleOutsideClick = (event) => {
    if (this.node && !this.node.contains(event.target)) {
      this.setState({ isActive: false, });
      const formdisplay = document.querySelector(".dash_add_course_cover.addreview")
      formdisplay.style.display = "none"
    }

  };
  componentDidMount() {
    this.fetchCourses()
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }
  handleResize = () => {
    this.setState({ windowHeight: window.innerHeight - 60 });
  };



  handleStarClick = (selectedRating) => {
    this.setState({ rating: selectedRating });
  };


  renderStarButtons = () => {
    const starButtons = [];
    for (let i = 1; i <= 5; i++) {
      starButtons.push(
        <button
          key={`star-${i}`}
          type="button"
          className="star-button"
          onClick={() => this.handleStarClick(i)}
          style={{
            background: 'none',
            border: 'none',
            outline: 'none',
            cursor: 'pointer',
            padding: 0,
            marginRight: '5px',
            fontSize: '1.2em',
            color: this.state.rating >= i ? 'rgb(195, 125, 22)' : 'rgb(195, 125, 22)', // Highlighted color for filled stars
          }}
        >
          {this.state.rating >= i ? <FaStar /> : <FaRegStar />}
        </button>
      );
    }
    return starButtons;
  };



  handleUpdateReview = async () => {
    this.setState({ loading: true, error: null });
    const formData = new FormData();
    formData.append('rating', this.state.rating);
    formData.append('comment', this.state.comment);

    const course_id = this.props.course_id
    const courseId = parseInt(course_id, 10);
    const reviewnumber = this.state.reviewID
    const accessToken = localStorage.getItem('accessToken');
    const headers = {
      Authorization: `Bearer ${accessToken}`,
    };

    const updateUrl = `https://api.geoinfoacademy.com/api/courses/${courseId}/reviews/${reviewnumber}/`;

    try {
      const response = await axios.patch(updateUrl, formData, { headers });
      console.log('API response (update):', response);
      this.fetchCourses(); // Refresh the reviews list
      this.setState({ loading: false });
      if (this.props.onRefresh) {
        this.props.onRefresh(); // Call the callback to signal the parent
      }
    } catch (error) {
      console.error('Error updating review:', error);
      this.setState({ loading: false, error: error.message });
    }
  };



     
     
  handleDelete = async (steps) => {
    const accessToken = localStorage.getItem("accessToken");


    try {
        const course_id = this.props.course_id
        const courseId = parseInt(course_id, 10);
        const response = await axios.delete(`https://api.geoinfoacademy.com/api/courses/${courseId}/reviews/${steps}/`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });

        if (response.status === 204 || response.status === 200) { // Check for successful delete status codes (204 No Content is common)
            console.log("Document deleted successfully:", steps.id);
            // Optionally: Refresh the document list after successful deletion
             // Or whatever method you use to refresh the list
            // You might also want to provide user feedback (e.g., a toast notification)
            // alert("Document deleted successfully")
            if (this.props.onRefresh) { // Changed from onDocumentSubmit to onRefresh
              this.props.onRefresh(); // Call the callback to signal the parent
              this.setState({
                rating: 0,
                comment: "",
                reviewID: 0,
              })
          }
          
        } else {
            console.error("Error deleting document:", response.status, response.data);
            // Handle error (e.g., display an error message to the user)
            alert("Error deleting document")

        }
        
        
    } catch (error) {
        console.error("Error deleting document:", error);
        // Handle network errors or other exceptions
        alert("Error deleting document")
    }
};

  render() {
    const { menuCoverWidth } = this.state;
    console.log("checking the rating review submit", this.state)

    return (

      <div className="dash_add_course_cover addreview" style={{ width: `calc(100% - ${menuCoverWidth}px - 3px)`, height: this.state.windowHeight }}>
        <div className="dash_form_container" ref={(node) => (this.node = node)}>
          <h2>Make a Review</h2>
          <p>Make sure to follow the instruction if any bellow the input </p>
          <form onSubmit={this.handleSubmit} className='add_course_form'>
            <label htmlFor="star">How may stars does this course deserve</label><br />
            <div style={{ display: 'flex', alignItems: 'center' }}>{this.renderStarButtons()}</div><br /><br />

            <label htmlFor="comment">Make a Comment</label><br />
            <textarea type="text" id='comment' name="comment" value={this.state.comment} onChange={this.handleInputChange} placeholder="Drop a comment" /><br /><br />

            { this.state.reviewID === 0 ? <button type="submit" disabled={this.state.loading}>
              {this.state.loading ? "Uploading..." : "Submit"}
            </button>: <button type="button" disabled={this.state.loading} onClick={this.handleUpdateReview} >
              {this.state.loading ? "Uploading..." : "Update"}
            </button> }<br/><br/>
            <button type="button" disabled={this.state.loading} onClick={() =>this.handleDelete(this.state.reviewID)}>
              {this.state.loading ? "Uploading..." : "Delete"}
            </button>
          </form>
        </div>
      </div>


    );
  }
}

export default AddReview;